import React from 'react';

import { NavBar } from '../Components/NavBar';
import { Footer } from '../Components/Footer';
import { Contact } from '../Components/Contact';

function TermsAndConditions() {
	return (
		<div>
			<NavBar />
			<Contact />

			<main className="cookies-main">
				<h1 className="text-center text-remesa">
					Términos y Condiciones de Uso
				</h1>

				<h5>Última actualización: 19 de junio de 2026</h5>

				<h3>1. OBJETO</h3>

				<p>
					Los presentes Términos y Condiciones regulan el acceso y
					utilización de la plataforma RemesaEspana y de los servicios
					ofrecidos a través de la misma.
				</p>

				<p>
					Al registrarse, acceder o utilizar cualquiera de los servicios
					disponibles, el Usuario declara haber leído, comprendido y
					aceptado íntegramente las presentes condiciones.
				</p>

				<p>
					Si el Usuario no está de acuerdo con cualquiera de las
					disposiciones aquí contenidas, deberá abstenerse de utilizar
					los servicios.
				</p>

				<h3>2. DESCRIPCIÓN DEL SERVICIO</h3>

				<p>
					RemesaEspana facilita soluciones tecnológicas destinadas a la
					transferencia internacional de valor entre distintas
					jurisdicciones.
				</p>

				<p>
					Para la ejecución de determinadas operaciones podrán emplearse
					infraestructuras financieras, sistemas de pago, tecnologías
					blockchain y activos digitales estables utilizados
					exclusivamente como mecanismo operativo de compensación,
					liquidación o conversión entre monedas fiduciarias.
				</p>

				<p>
					El Usuario reconoce expresamente que el servicio contratado
					tiene como finalidad la transferencia de valor entre origen y
					destino y no constituye un servicio de inversión,
					asesoramiento financiero, intermediación bursátil ni
					recomendación de compra o venta de activos digitales.
				</p>

				<p>
					La utilización de activos digitales estables forma parte de los
					procesos internos de ejecución y liquidación de operaciones y
					no implica que el Usuario adquiera derechos de inversión sobre
					dichos activos.
				</p>

				<h3>3. REGISTRO Y APERTURA DE CUENTA</h3>

				<p>
					Para acceder a determinados servicios será necesario crear una
					cuenta de usuario y proporcionar información completa, exacta
					y actualizada.
				</p>

				<p>
					El Usuario garantiza que toda la información suministrada es
					veraz y se compromete a mantenerla actualizada durante toda la
					relación comercial.
				</p>

				<p>
					La Plataforma podrá solicitar documentación adicional cuando
					resulte necesario para validar la identidad o verificar
					determinada información.
				</p>

				<h3>4. IDENTIFICACIÓN Y VERIFICACIÓN DE CLIENTES</h3>

				<p>
					Con el fin de proteger a los usuarios y cumplir con la
					normativa aplicable en materia de prevención del fraude,
					blanqueo de capitales y financiación del terrorismo, la
					Plataforma podrá requerir procesos de identificación y
					verificación de identidad.
				</p>

				<p>Estos procedimientos podrán incluir:</p>

				<ul>
					<li>Documento oficial de identidad vigente.</li>
					<li>Video identificación.</li>
					<li>Fotografía facial o selfie.</li>
					<li>Comprobante de domicilio.</li>
					<li>Justificación del origen de fondos.</li>
					<li>Información sobre actividad económica.</li>
				</ul>

				<p>
					La validación podrá realizarse mediante proveedores
					especializados que actúan bajo estrictos estándares de
					seguridad y cumplimiento normativo.
				</p>

				<p>
					La negativa a facilitar la información requerida podrá impedir
					la prestación de los servicios.
				</p>

				<h3>5. EJECUCIÓN DE OPERACIONES</h3>

				<p>
					Toda solicitud enviada por el Usuario estará sujeta a revisión
					y validación.
				</p>

				<p>
					La Plataforma se reserva el derecho de rechazar, suspender o
					cancelar cualquier operación cuando:
				</p>

				<ul>
					<li>Existan dudas sobre la identidad del Usuario.</li>
					<li>
						La información proporcionada sea incorrecta o incompleta.
					</li>
					<li>Se detecten indicios de fraude.</li>
					<li>Existan requerimientos regulatorios o legales.</li>
					<li>
						La operación presente riesgos operativos, reputacionales o
						de cumplimiento.
					</li>
				</ul>

				<p>
					La aceptación de una solicitud no implica la obligación de
					ejecutar futuras operaciones.
				</p>

				<h3>6. TIPOS DE CAMBIO Y CONVERSIONES</h3>

				<p>
					Las conversiones aplicables a cada operación serán determinadas
					en el momento de la ejecución.
				</p>

				<p>
					Los tipos de cambio, comisiones, costes operativos y gastos
					asociados podrán variar en función de las condiciones del
					mercado, liquidez disponible, jurisdicciones involucradas y
					proveedores participantes en la operación.
				</p>

				<p>
					El Usuario acepta expresamente las condiciones económicas
					vigentes al momento de confirmar la operación.
				</p>

				<h3>7. TIEMPOS DE PROCESAMIENTO</h3>

				<p>Los tiempos de procesamiento tienen carácter estimativo.</p>

				<p>
					La ejecución de una operación podrá verse afectada por:
				</p>

				<ul>
					<li>Horarios bancarios.</li>
					<li>Verificaciones de cumplimiento.</li>
					<li>Procedimientos de seguridad.</li>
					<li>Revisiones regulatorias.</li>
					<li>Incidencias técnicas.</li>
					<li>Procesos de terceros participantes.</li>
				</ul>

				<p>
					La Plataforma no garantiza plazos exactos de liquidación.
				</p>

				<h3>8. OBLIGACIONES DEL USUARIO</h3>

				<p>El Usuario se compromete a:</p>

				<ul>
					<li>Facilitar información veraz y actualizada.</li>
					<li>Utilizar la Plataforma de forma lícita.</li>
					<li>No realizar actividades fraudulentas.</li>
					<li>No utilizar terceros para ocultar su identidad.</li>
					<li>
						No utilizar los servicios para actividades prohibidas por
						la legislación aplicable.
					</li>
				</ul>

				<p>
					El Usuario será responsable de cualquier perjuicio derivado de
					información falsa o inexacta.
				</p>

				<h3>9. ACTIVIDADES PROHIBIDAS</h3>

				<p>Queda estrictamente prohibido utilizar los servicios para:</p>

				<ul>
					<li>Blanqueo de capitales.</li>
					<li>Financiación del terrorismo.</li>
					<li>Fraude financiero.</li>
					<li>Suplantación de identidad.</li>
					<li>Estafas.</li>
					<li>
						Actividades ilícitas relacionadas con sanciones
						internacionales.
					</li>
					<li>
						Cualquier actividad contraria a la legislación vigente.
					</li>
				</ul>

				<h3>10. CUMPLIMIENTO NORMATIVO</h3>

				<p>
					La Plataforma mantiene procedimientos internos orientados al
					cumplimiento de las normativas aplicables en materia de
					prevención de blanqueo de capitales, financiación del
					terrorismo, protección de datos, seguridad financiera y gestión
					de riesgos.
				</p>

				<p>
					La Plataforma podrá requerir información adicional en cualquier
					momento para satisfacer obligaciones regulatorias o solicitudes
					de autoridades competentes.
				</p>

				<h3>11. UTILIZACIÓN DE PROVEEDORES EXTERNOS</h3>

				<p>
					Para la prestación de determinados servicios podrán intervenir
					entidades colaboradoras especializadas en:
				</p>

				<ul>
					<li>Procesamiento de pagos.</li>
					<li>Verificación de identidad.</li>
					<li>Cumplimiento normativo.</li>
					<li>Gestión de riesgos.</li>
					<li>Liquidación financiera.</li>
					<li>Infraestructura tecnológica.</li>
				</ul>

				<p>
					La participación de dichos colaboradores forma parte del modelo
					operativo utilizado para garantizar la seguridad, continuidad y
					eficiencia de los servicios.
				</p>

				<h3>12. LIMITACIÓN DE RESPONSABILIDAD</h3>

				<p>La Plataforma no será responsable por:</p>

				<ul>
					<li>Errores en la información proporcionada por el Usuario.</li>
					<li>Retrasos ocasionados por terceros.</li>
					<li>Interrupciones de sistemas externos.</li>
					<li>Fuerza mayor.</li>
					<li>Actuaciones de entidades financieras.</li>
					<li>Medidas adoptadas por autoridades competentes.</li>
				</ul>

				<p>
					La responsabilidad total de la Plataforma quedará limitada al
					importe de la operación afectada cuando así lo permita la
					legislación aplicable.
				</p>

				<h3>13. SUSPENSIÓN O CANCELACIÓN DE CUENTAS</h3>

				<ul>
					<li>Existan incumplimientos de estos términos.</li>
					<li>Se detecten actividades sospechosas.</li>
					<li>
						Existan obligaciones regulatorias que así lo requieran.
					</li>
					<li>
						Se comprometa la seguridad de la Plataforma o de terceros.
					</li>
				</ul>

				<h3>14. PROPIEDAD INTELECTUAL</h3>

				<p>
					Todos los contenidos, diseños, marcas, logotipos, desarrollos
					tecnológicos y elementos presentes en la Plataforma son
					propiedad exclusiva de sus titulares y están protegidos por la
					legislación aplicable.
				</p>

				<h3>15. PRIVACIDAD Y PROTECCIÓN DE DATOS</h3>

				<p>
					El tratamiento de los datos personales se realizará de
					conformidad con la Política de Privacidad vigente publicada en
					la Plataforma.
				</p>

				<h3>16. MODIFICACIONES</h3>

				<p>
					La Plataforma podrá modificar los presentes Términos y
					Condiciones cuando resulte necesario para adaptarlos a cambios
					regulatorios, tecnológicos, operativos o comerciales.
				</p>

				<p>
					La versión actualizada será publicada en el sitio web y entrará
					en vigor desde su fecha de publicación.
				</p>

				<h3>17. LEGISLACIÓN APLICABLE Y JURISDICCIÓN</h3>

				<p>
					Los presentes Términos y Condiciones se interpretarán conforme
					a la legislación aplicable dentro de la Unión Europea.
				</p>

				<p>
					Cualquier controversia derivada de la utilización de los
					servicios será sometida a los tribunales competentes que
					correspondan conforme a la normativa aplicable.
				</p>

				<h3>18. ACEPTACIÓN</h3>

				<p>
					El Usuario declara haber leído íntegramente estos Términos y
					Condiciones y acepta expresamente quedar vinculado por su
					contenido al utilizar la Plataforma y cualquiera de los
					servicios ofrecidos.
				</p>
			</main>

			<Footer />
		</div>
	);
}

export { TermsAndConditions };